var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseenter":function($event){return _vm.playRandomAnimation()}}},[_c('lottie',{staticClass:"lottie",attrs:{"options":_vm.defaultOptions,"height":400,"width":400},on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }